import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./MetalsMinerals.css";

export default function MetalsMinerals() {
  const metalsMineralsProducts = [
    {
      id: 1,
      name: "FERRO",
      image: "/assets/img/MetalsMinerals/ferro.jpg",
      usage: [
        {
          title: "Where It’s Used",
          points: [
            "Steel Industry: The largest consumer used in manufacturing carbon steel, stainless steel, and alloy steel.",
            "Automotive: For engine components, crankshafts, gears, and other high-strength steel parts.s",
            "Railways & Shipbuilding: To produce rails, ship hulls, and heavy transport equipment.",
            "Aerospace: For turbine blades, landing gears, and structural frames where strength-to-weight ratio is critical",
          ],
        },
        {
          title: "Why It’s Used",
          points: [
            "Deoxidizers: Remove unwanted oxygen from molten metal to prevent brittleness.",
            "Alloying Agents: Improve metal properties like strength, hardness, and corrosion resistance.",
            "Purifiers: Eliminate impurities such as sulfur and nitrogen for cleaner, stronger steel.",
          ],
        },
      ],
    },
    {
      id: 2,
      name: "SILICO MANGANESE GRADE(SMGR30%)",
      image: "/assets/img/MetalsMinerals/SILICO-MANGANESE-GRADE(SMGR30).jpg",
      usage: [
        {
          title: "Where It’s Used",
          points: [
            "Widely used in steel manufacturing plants as a deoxidizer and desulfurizer.",
            "Applied in construction steel (TMT bars, structural beams, mild steel).",
            "Used in automotive components that need strength and wear resistance.",
            "Essential for foundries and alloy steel production.",
            "Supports infrastructure and fabrication industries for making durable steel structures..",
          ],
        },
        {
          title: "Why It’s Used",
          points: [
            "Helps remove oxygen and sulfur impurities from molten steel.",
            "Enhances tensile strength, hardness, and durability of steel.",
            "Improves mechanical and surface properties of metal..",
            "Promotes better weldability and formability.",
            "Ensures consistent steel quality during large-scale production.",
          ],
        },
      ],
    },
    {
      id: 3,
      name: "SILICO MANGANESE GRADE--LOW Mn(25%)",
      image: "/assets/img/MetalsMinerals/SILICO-MANGANESE-GRADE-LOW Mn(25).jpg",
      usage: [
        {
          title: "Where It’s Used",
          points: [
            "Used in steel manufacturing as a deoxidizer and desulfurizer",
            "Applied in mild steel, structural steel, and TMT bar production",
            "Utilized in automotive components and alloy steel foundries",
            "Essential for infrastructure, fabrication, and engineering industries",
            "Supports production of durable and corrosion-resistant steel products",
          ],
        },
        {
          title: "Why It’s Used",
          points: [
            "Removes oxygen and sulfur impurities from molten steel",
            "Enhances tensile strength, hardness, and durability",
            "Improves weldability and surface finish of steel",
            "Ensures consistent, high-quality steel output in bulk production",
            "Provides cost-effective performance for general steelmaking applications",
          ],
        },
      ],
    },

    {
      id: 4,
      name: "CHEMICAL GRADE",
      image: "/assets/img/MetalsMinerals/chemical-grade.jpg",
      usage: [
        {
          title: "Where It’s Used",
          points: [
            "Widely used in chemical industries for producing manganese sulfate and potassium permanganate",
            "Applied in manufacturing of dry cell batteries and fertilizers",
            "Used in glass, ceramics, and pigment industries for coloring and refining processes",
            "Essential in water treatment plants for oxidation and purification applications",
            "Supports pharmaceutical and agricultural chemical formulations",
          ],
        },
        {
          title: "Why It’s Used",
          points: [
            "Acts as a key raw material for various chemical compounds",
            "Enhances oxidation and catalytic reactions in chemical processes",
            "Improves color stability and quality in glass and ceramic production",
            "Ensures effective purification and filtration in water treatment systems",
            "Provides high purity and consistency required for industrial and laboratory use",
          ],
        },
      ],
    },


    {
      id: 5,
      name: "FINES",
      image: "/assets/img/MetalsMinerals/FINES.jpg",
      usage: [
        {
          title: "Where It’s Used",
          points: [
            "Widely used in cement, concrete, and construction material manufacturing",
            "Applied in steel plants as a flux to remove impurities during refining",
            "Used in agriculture to neutralize acidic soils and improve fertility",
            "Important in environmental management for flue gas desulfurization and water treatment",
            "Utilized in chemical and metallurgical industries for purification and stabilization processes",
          ],
        },
        {
          title: "Why It’s Used",
          points: [
            "Improves strength, bonding, and durability of construction materials",
            "Helps remove sulfur and other impurities during steelmaking",
            "Enhances soil pH balance and nutrient absorption in farming",
            "Aids in pollution control by reducing harmful gas emissions",
            "Provides cost-effective performance for large-scale industrial applications",
          ],
        },
      ],
    },

    // {
    //   id: 6,
    //   name: "COAL",
    //   image: "/assets/img/MetalsMinerals/coal.png",
    //   usage: [
    //     {
    //       title: "APPLICATIONS",
    //       points: [
    //         "Fuel for electricity generation and industrial heating",
    //         "Used in steel and cement industries as an energy source",
    //         "Applied in activated carbon and chemical processing",
    //       ],
    //     },
    //   ],
    // },
    // {
    //   id: 7,
    //   name: "ZINC",
    //   image: "/assets/img/MetalsMinerals/zinc.png",
    //   usage: [
    //     {
    //       title: "APPLICATIONS",
    //       points: [
    //         "Used for galvanizing steel to prevent corrosion",
    //         "Employed in battery production and die-casting alloys",
    //         "Utilized in paints, rubber, and pharmaceuticals",
    //       ],
    //     },
    //   ],
    // },
    // {
    //   id: 8,
    //   name: "GYPSUM",
    //   image: "/assets/img/MetalsMinerals/gypsum.png",
    //   usage: [
    //     {
    //       title: "APPLICATIONS",
    //       points: [
    //         "Used in cement, plaster, and wallboard manufacturing",
    //         "Essential in agriculture for soil conditioning",
    //         "Applied in decorative and architectural structures",
    //       ],
    //     },
    //   ],
    // },
  ];

  const defaultImage =
    "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

  const [selectedProduct, setSelectedProduct] = useState(null);
  const closeModal = () => setSelectedProduct(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb
        title="Metals and Minerals"
        backgroundImage="./assets/img/contact-banner.png"
        height="40vh"
      />

      <section className="pp-section">
        <div className="container">
          <h1 className="pp-title">Metals and Minerals Product Range</h1>
          <p className="pp-subtitle">
            Explore our range of high-quality metals and minerals used across industries worldwide.
          </p>

          <div className="pp-grid">
            {metalsMineralsProducts.map((product) => (
              <div className="pp-card" key={product.id}>
                <div className="pp-img-box">
                  <img
                    src={product.image || defaultImage}
                    alt={product.name}
                    onError={(e) => (e.target.src = defaultImage)}
                  />
                </div>
                <div className="pp-info">
                  <h2 className="pp-name">{product.name}</h2>
                  <button
                    className="view-btn"
                    onClick={() => setSelectedProduct(product)}
                  >
                    View Details <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {selectedProduct && (
            <div className="modal-overlay" onClick={closeModal}>
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedProduct.image || defaultImage}
                  alt={selectedProduct.name}
                  className="modal-image"
                />
                <h2 className="modal-title">{selectedProduct.name}</h2>

                <div className="usage-section">
                  {selectedProduct.usage.map((section, index) => (
                    <div key={index} className="usage-block">
                      <h3>{section.title}</h3>
                      <ul>
                        {section.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
